<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Editar Movimiento
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
            <h5>Información de cuenta: {{ this.avaliable }}</h5>
          </div>
        </div>
        <sys-form :inputs="movement_details"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'movement', params: { id: movement.id } })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import movementsService from '@/services/movements'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'MovementUpdate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      avaliable: '',
      movement: {},
      movement_details: {
        colaborator_id: {
          name: 'Colaborador',
          value: '',
          type: 'select',
          options: [],
          size: 6,
          validate: 'required'
        },
        account_id: {
          name: 'Cuenta',
          value: '',
          type: 'select',
          options: [],
          size: 6,
          validate: 'required'
        },
        income: {
          name: 'Estatus',
          value: '',
          type: 'select',
          options: [
            { value: 1, text: 'Aportación' },
            { value: 0, text: 'Retiro' }
          ]
        },
        confirm_date: {
          name: 'Fecha Confirmación',
          value: '',
          type: 'date'
        },
        amount: {
          name: 'Monto del movimiento',
          hint: 'Monto',
          value: '',
          type: 'number'
        },
        total: {
          name: '¿Es Total?',
          value: '',
          type: 'select',
          options: [
            { value: 1, text: 'Sí' },
            { value: 0, text: 'No' }
          ]
        }
      }
    }
  },
  created: function () {
    this.loaded = false
    const id = this.$route.params.id
    movementsService.getById(id).then(res => {
      this.movement = res.data
      Object.keys(this.movement_details).forEach(key => {
        if (this.movement_details[key].type != 'select') {
          this.movement_details[key].value = this.movement[key]
        }
      })
      movementsService.listColabs().then(res => {
        this.movement_details.colaborator_id.options = res.data.map(colab => {
          if (colab.id == this.movement.colaborator_id) {
            this.movement_details.colaborator_id.value = { value: colab.id, text: `${colab.name}` }
          }
          return { value: colab.id, text: colab.name }
        })
      })
      this.movement_details.account_id.value = { value: this.movement.account_id, text: `${this.movement.account}` }
      this.avaliable = this.movement.account
      this.movement_details.income.value = { value: this.movement.income, text: `${this.movement.status}` }
      if (this.movement.total === 'Sí') {
        this.movement_details.total.value = { value: true, text: `${this.movement.total}` }
      } else {
        this.movement_details.total.value = { value: false, text: `${this.movement.total}` }
      }
      this.loaded = true
    })
  },
  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let movementInfo = { ...this.movement_details }

          let body = this.processForm(movementInfo)
          let service = movementsService.updateById(this.movement.id, body)
          this.sendForm(service).then(res => {
            this.$router.push({ name: 'movement', params: { id: this.movement.id } })
          }).catch(err => {
            this.$swal(err.data.message, 'Favor de checar el monto', {
              icon: 'error'
            })
          })
        }
      })
    }
  },
  watch: {
    'movement_details.colaborator_id.value': function (newColab, oldColab) {
      if (!newColab.value) {
        this.movement_details.amount.value = ''
        this.movement_details.confirm_date.value = ''
        return
      }

      let id = newColab.value
      movementsService.getAccountsList(id).then(res => {
        this.movement_details.account_id.options = res.data.map(account => {
          return { value: account.id, text: 'Id: ' + account.id + ' total: $' + (account.amount).toFixed(2) + ' disponible: $' + (account.amount_avaliable).toFixed(2) }
        })
      })
    },
    'movement_details.account_id.value': function (newAccount, oldAccount) {
      if (!newAccount.value) {
        this.movement_details.amount.value = ''
        this.movement_details.confirm_date.value = ''
      } else {
        this.avaliable = newAccount.text
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/movements/MovementUpdate.vue